<script setup lang="ts">
import VoixVideoControlsButtons from './VoixVideoControlsButtons.vue'

// Config
defineProps<{
  play: () => void
  pause: () => void
  paused: boolean
  mute: () => void
  unMute: () => void
  muted: boolean
  volume: number
  setVolume: (params: { value: number, init: boolean }) => void
  fullscreen: () => void
  allowFullscreen: boolean
  controlsPosition: string
}>()
</script>

<template>
  <div class="w-full h-full grid grid-row-3 gap-4 p-4">
    <!-- Top Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'top right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>

    <!-- Middle Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'middle right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>

    <!-- Bottom Row -->
    <div class="w-full h-full flex flex-row space-x-4">
      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom left'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom center'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>

      <div class="w-full h-full flex justify-center items-center">
        <VoixVideoControlsButtons v-if="controlsPosition === 'bottom right'" :paused="paused" :play="play" :pause="pause" :mute="mute" :un-mute="unMute" :muted="muted" :volume="volume" :set-volume="setVolume" :fullscreen="fullscreen" :allow-fullscreen="allowFullscreen" />
      </div>
    </div>
  </div>
</template>
